'use client';

import { createPortal } from 'react-dom';

export interface IProps {
  el?: HTMLElement;
  children?: React.JSX.Element;
}

function Portal({ el, children }: IProps): React.ReactPortal {
  const element = el || document.body;
  return createPortal(children, element);
}

export default Portal;
